import Head from 'next/head';

export default function Linkaufbau() {
    return (
        <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
            <Head>
                <title>Off Page Seo Services | deinSEOExpert</title>
                <link rel="icon" href="/favicon.ico"/>
                <meta
                    name="description"
                    content="Entdecken Sie mein Off Page Seo Service und erfahren Sie mehr über meine professionellen SEO-Dienstleistungen. Als Ihr SEO-Experte biete ich maßgeschneiderte Lösungen und kompetente Beratung, um Ihren SEO-Erfolg zu maximieren. Besuchen Sie meine Website für Expertenwissen und gezielte Keyword-Optimierung."
                />
            </Head>

            <main className="p-6 flex flex-col-reverse md:flex-row max-w-5xl mx-auto">
                <div className="w-full md:w-2/3 pr-4 mb-4 md:mb-0 order-2 md:order-1">
                    <div className="flex items-center mb-6">
                        <span className="inline-block mr-4 text-4xl">🌐</span>
                        <h2 className="text-3xl font-bold text-green-700">Off-Page-SEO-Dienstleistungen</h2>
                    </div>
                    <p className="text-lg leading-relaxed text-gray-700 mb-10 dark:text-white">Meine Off-Page-SEO-Dienstleistungen
                        konzentrieren sich darauf, die Autorität und Sichtbarkeit Ihrer Website über die
                        On-Page-Optimierung hinaus zu verbessern. Meine Link-Building-Strategien, die Fokussierung auf DoFollow Backlinks und SEO Backlinks, besonders hohe DA Backlinks und German Backlinks, und meine Arbeit um EDU Backlinks aufzubauen tragen dazu bei, Ihre Domain Authority zu erhöhen und somit die Sichtbarkeit Ihrer Website in Suchmaschinen zu verbessern. Durch Social-Media-Engagement, Partnerschaften mit
                        Influencern und Erwähnungen Ihrer Marke im Internet kann ich das Ranking Ihrer Website
                        verbessern und mehr organischen Traffic anziehen.</p>
                    <h2 className="text-2xl font-bold text-green-700 mb-4">Warum meine Off-Page-SEO-Dienstleistungen
                        wählen?</h2>
                    <p className="text-lg leading-relaxed text-gray-700 dark:text-white">Als Experte verstehe ich die Bedeutung der
                        Off-Page-Optimierung und des Link-Buildings für nachhaltige SEO-Ergebnisse. Ich setze ethische und bewährte Techniken
                        ein, um die Autorität und den Ruf Ihrer Website im Online-Ökosystem aufzubauen. Durch
                        Partnerschaften mit einflussreichen Websites, Interaktionen mit Ihrer Zielgruppe in sozialen
                        Medien und die Umsetzung effektiver Linkbuilding-Strategien kann ich Ihrer Website helfen, in
                        den Suchmaschinenrankings höher zu steigen und gezielten Traffic zu generieren.</p>
                </div>

                <div className="w-full md:w-1/3 pl-4 order-1 md:order-2">
                    <div className="bg-white p-6 rounded shadow-md dark:bg-gray-800">
                        <img src="/Off-Page-SEO.webp" alt="Off Page SEO" className="w-full mb-6 rounded"/>
                        <h3 className="text-xl font-bold text-green-700 mb-2">Dein SEO Experte für Off-Page-SEO und Backlinkaufbau</h3>
                        <p className="text-gray-700 mb-4 dark:text-white">Als SEO-Experte, spezialisiert auf
                            Off-Page-SEO-Dienstleistungen und den Aufbau von hochwertigen Backlinks, bringe ich meine Fokussierung auf den Aufbau
                            starker Off-Page-Signale für Ihre Website ein, um Ihnen langfristigen SEO-Erfolg
                            ermöglichen und Ihre Online-Präsenz verbessern.</p>
                    </div>
                </div>
            </main>
        </div>
    );
}